import React from "react";
import Login from "./Login";
import EthWithdrawList from './payment/EthWithdrawList';
import PurchaseOrderList from './payment/PurchaseOrderList';
import CryptoOrderList from './payment/CryptoOrderList';
import EthTransactionList from './payment/EthTransactionList';
import ChargeCodeList from './payment/ChargeCodeList';
import ServerLocationList from './config/ServerLocationList';
import ServersCacheManage from './config/ServersCacheManage';
import MonitorServerList from './config/MonitorServerList';
import ProxyServerList from './config/ProxyServerList';
import SplitTunnelRuleList from './config/SplitTunnelRuleList';
import EmailBlacklistList from './config/EmailBlacklistList';
import UserList from "./member/UserList";
import UserTrafficStats from "./member/UserTrafficStats";
import DataStatistic from "./member/DataStatistic";
const Main = React.lazy(() => import('./Main'));

const routes = [
    {
        path: "/login",
        exact: true,
        component: Login
    },
    {
        path: "/console",
        component: Main,
        routes: [
            {path: "/console/user-list", component: UserList},
            {path: "/console/user-traffic-stats", component: UserTrafficStats},
            {path: "/console/data-statistic", component: DataStatistic},
            {path: "/console/eth-withdraw-list", component: EthWithdrawList},
            {path: "/console/server-location-list", component: ServerLocationList},
            {path: "/console/servers-cache-manage", component: ServersCacheManage},
            {path: "/console/proxy-server-list", component: ProxyServerList},
            {path: "/console/split-tunnel-rules", component: SplitTunnelRuleList},
            {path: "/console/email-blacklist", component: EmailBlacklistList},
            {path: "/console/server-status-list", component: MonitorServerList},
            {path: "/console/purchase-order-list", component: PurchaseOrderList},
            {path: "/console/crypto-order-list", component: CryptoOrderList},
            {path: "/console/crypto-transactions", component: EthTransactionList},
            {path: "/console/charge-code-list", component: ChargeCodeList}
        ]
    }
];

export default routes;
